import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة قانون أوم - احسب الجهد، التيار، أو المقاومة";
const DESCRIPTION =
  "حاسبة قانون أوم الشاملة: احسب الجهد، التيار، أو المقاومة باستخدام القيم المدخلة للجهد، أو التيار، أو المقاومة. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS =
  "قانون أوم, حساب الجهد, حساب التيار, حساب المقاومة, حاسبة قانون أوم";
const OG_URL = "https://do-calculate.com/calculator/ar/ohmslaw";
function OhmsLawCalculator() {
  const [voltage, setVoltage] = useState("");
  const [current, setCurrent] = useState("");
  const [resistance, setResistance] = useState("");
  const [calculationMode, setCalculationMode] = useState("calculateVoltage");
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const voltageValue = parseFloat(voltage) || 0;
    const currentValue = parseFloat(current) || 0;
    const resistanceValue = parseFloat(resistance) || 0;
    switch (calculationMode) {
      case "calculateVoltage":
        if (currentValue > 0 && resistanceValue > 0) {
          const calculatedVoltage = currentValue * resistanceValue;
          setVoltage(Math.round(calculatedVoltage * 100) / 100);
        } else {
          setError("الرجاء إدخال التيار والمقاومة بشكل صحيح");
        }
        break;
      case "calculateCurrent":
        if (voltageValue > 0 && resistanceValue > 0) {
          const calculatedCurrent = voltageValue / resistanceValue;
          setCurrent(Math.round(calculatedCurrent * 100) / 100);
        } else {
          setError("الرجاء إدخال الجهد والمقاومة بشكل صحيح");
        }
        break;
      case "calculateResistance":
        if (voltageValue > 0 && currentValue > 0) {
          const calculatedResistance = voltageValue / currentValue;
          setResistance(Math.round(calculatedResistance * 100) / 100);
        } else {
          setError("الرجاء إدخال الجهد والتيار بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [voltage, current, resistance, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handleVoltageChange = (e) => setVoltage(e.target.value);
  const handleCurrentChange = (e) => setCurrent(e.target.value);
  const handleResistanceChange = (e) => setResistance(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculateVoltage":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الجهد:</h4>
            <ol>
              <li>ادخل التيار (بالأمبير) في الحقل المخصص.</li>
              <li>ادخل المقاومة (بأوم) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الجهد.</li>
              <li>الجهد يساوي التيار × المقاومة.</li>
            </ol>
          </div>
        );
      case "calculateCurrent":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب التيار:</h4>
            <ol>
              <li>ادخل الجهد (بالفولت) في الحقل المخصص.</li>
              <li>ادخل المقاومة (بأوم) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على التيار.</li>
              <li>التيار يساوي الجهد / المقاومة.</li>
            </ol>
          </div>
        );
      case "calculateResistance":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب المقاومة:</h4>
            <ol>
              <li>ادخل الجهد (بالفولت) في الحقل المخصص.</li>
              <li>ادخل التيار (بالأمبير) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على المقاومة.</li>
              <li>المقاومة تساوي الجهد / التيار.</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة قانون أوم إجراء ثلاث أنواع من الحسابات استنادًا
                  إلى القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل القيم
                  المتوفرة لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الجهد بمعلومية التيار والمقاومة
                </h2>
                <p>
                  إذا كنت تعرف التيار (بـ الأمبير) والمقاومة (بـ أوم)، يمكنك
                  حساب الجهد (بـ الفولت) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الجهد = التيار × المقاومة</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد التيار بمعلومية الجهد والمقاومة
                </h2>
                <p>
                  إذا كنت تعرف الجهد (بـ الفولت) والمقاومة (بـ أوم)، يمكنك حساب
                  التيار (بـ الأمبير) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>التيار = الجهد / المقاومة</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد المقاومة بمعلومية الجهد والتيار
                </h2>
                <p>
                  إذا كنت تعرف الجهد (بـ الفولت) والتيار (بـ الأمبير)، يمكنك
                  حساب المقاومة (بـ أوم) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>المقاومة = الجهد / التيار</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات المتعلقة بقانون أوم.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div id="calculationMode">
                      <br />
                      <div>
                        <input
                          type="radio"
                          id="calculateVoltage"
                          name="calculationMode"
                          value="calculateVoltage"
                          checked={calculationMode === "calculateVoltage"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateVoltage" className="ms-2">
                          حساب الجهد
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateCurrent"
                          name="calculationMode"
                          value="calculateCurrent"
                          checked={calculationMode === "calculateCurrent"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateCurrent" className="ms-2">
                          حساب التيار
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateResistance"
                          name="calculationMode"
                          value="calculateResistance"
                          checked={calculationMode === "calculateResistance"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateResistance" className="ms-2">
                          حساب المقاومة
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculateVoltage" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="voltageInput"
                        >
                          الجهد (فولت)
                        </label>
                      </b>
                      <input
                        id="voltageInput"
                        type="number"
                        placeholder="12"
                        value={voltage}
                        onChange={handleVoltageChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateCurrent" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="currentInput"
                        >
                          التيار (أمبير)
                        </label>
                      </b>
                      <input
                        id="currentInput"
                        type="number"
                        placeholder="2"
                        value={current}
                        onChange={handleCurrentChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateResistance" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="resistanceInput"
                        >
                          المقاومة (أوم)
                        </label>
                      </b>
                      <input
                        id="resistanceInput"
                        type="number"
                        placeholder="6"
                        value={resistance}
                        onChange={handleResistanceChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculateVoltage" &&
                          voltage !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الجهد (فولت): {voltage} فولت
                            </p>
                          )}
                        {calculationMode === "calculateCurrent" &&
                          current !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              التيار (أمبير): {current} أمبير
                            </p>
                          )}
                        {calculationMode === "calculateResistance" &&
                          resistance !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              المقاومة (أوم): {resistance} أوم
                            </p>
                          )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default OhmsLawCalculator;
